var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8544 19.264C16.1454 20.438 14.0758 21.125 11.8457 21.125C9.61558 21.125 7.54599 20.4379 5.83695 19.2639C5.08214 18.7454 4.75956 17.7578 5.19844 16.954C6.10821 15.2878 7.98286 14.25 11.8457 14.25C15.7086 14.25 17.5832 15.2879 18.493 16.954C18.9318 17.7578 18.6092 18.7455 17.8544 19.264Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8457 10.5C13.9168 10.5 15.5957 8.82113 15.5957 6.75C15.5957 4.67894 13.9168 3 11.8457 3C9.7747 3 8.09575 4.67894 8.09575 6.75C8.09575 8.82113 9.7747 10.5 11.8457 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHost);
export default __webpack_public_path__ + "static/media/host.3ac64a77949b650538dff1b4a040416b.svg";
export { ForwardRef as ReactComponent };